/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";


//Componentes de roteamento
import { Link } from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default function View_Compartilhar(props) {
  function back(val) {
    if (val)
      return (
        <div className="flex-fill p-2 p-sm-3 d-flex align-items-start w-100 text-start">
          <div className="w-100 ">
            <Link to="/" className="icon d-flex flex-row">
              <i className="icon text-white1 fas fa-2x fa-arrow-left icon-button"></i>
              <span className="fs-4  flex d-none d-sm-block align-middle text-white1 ms-2 mt-2">
                VOLTAR
              </span>
            </Link>
          </div>
        </div>
      );
  }
  // ROTEAMENTO - colocar controle de estados da aplicação
  return (
    <div className="d-flex flex-column align-items-center h-100 w-100">
      {back(props.back)}

      <div className="row h-100 w-100 fw-light px-3">
        <div className="col-md px-md-5 text-center text-white1 align-self-center">
          <div className="col center ">
            <h5 className="fw-bold text-color1">COMPARTILHE O JOGO</h5>

            <p className="mt-3">Convide amigos e familiares para jogar!</p>
          </div>
          <div className="d-flex flex-row justify-content-evenly mt-5">
            <div className="flex">
              <div
                className="fb-share-button"
                data-href="https://eic.ifsc.usp.br/app/cruzadinhas/covid/"
                // data-href="https://illiamw.github.io/app/cruzadinhas/covid/"
              >
                <a
                  target="_blank"
                  // href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Filliamw.github.io%2Fapp%2Fcruzadinhas%2Fcovid%2F&amp;src=sdkpreparse"
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Feic.ifsc.usp.br%2Fapp%2Fcruzadinhas%2Fcovid%2F&amp;src=sdkpreparse"
                  className="icon text-white1"
                >
                  <i className="fab fa-facebook-square fa-4x"></i>
                  <p className="iconShare">Facebook</p>
                </a>
              </div>
            </div>
            <div className="flex">
              <a
                target="_blank"
                href="https://api.whatsapp.com/send?text=Jogue agora mesmo https://eic.ifsc.usp.br/app/cruzadinhas/covid/"
                // href="https://api.whatsapp.com/send?text=Jogue agora mesmo https://illiamw.github.io/app/cruzadinhas/covid/"
                className="icon text-white1"
              >
                {/* <a target="_blank" href="https://api.whatsapp.com/send?text=Jogue agora mesmo https://illiamw.github.io/app/cruzadinhas/covid/"> */}
                <i className="fab fa-whatsapp-square fa-4x"></i>
                <p className="iconShare">Whatsapp</p>
              </a>
            </div>
          </div>
        </div>
        <div className="destaque-share col-md px-md-5 text-center text-white1 align-self-center">
          <div className="col center ">
            <h5 className="fw-bold text-color1">
              SIGA O EIC NAS REDES SOCIAIS
            </h5>
            <p className="mt-3">
              <a
                className=" icon text-white1"
                target="_blank"
                href="http://eic.ifsc.usp.br/"
              >
                http://eic.ifsc.usp.br/
              </a>
            </p>
          </div>
          <div className="d-flex flex-row justify-content-evenly mt-5">
            <div className="flex">
              <a
                target="_blank"
                href="https://www.instagram.com/eiciencia/?hl=pt-br"
                className="icon text-white1"
              >
                <i className="fab fa-instagram-square fa-4x"></i>
                <p className="">Instagram</p>
              </a>
            </div>

            <div className="flex">
              <a
                target="_blank"
                href="https://www.facebook.com/EIC.USP"
                className="icon text-white1"
              >
                <i className="fab fa-facebook-square fa-4x"></i>

                <p className="">Facebook</p>
              </a>
            </div>
            <div className="flex">
              <a
                target="_blank"
                href="https://www.youtube.com/channel/UCjg75EYzCSLYCcxcXOuv_-g"
                className="icon text-white1"
              >
                <i className="fab fa-youtube-square fa-4x"></i>
                <p className="">Youtube</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
